<template>
  <div class="samples-paginator">
    <div class="samples-paginator__label">
      <span>{{ $t('fields.engineering.chromatography.sample') }}:</span>
    </div>
    <paginator
      v-model="currentPage"
      :per-page="1"
      :total-rows="samples.length"
      no-summary
    >
      <template v-slot:page="{ page }">
        {{ getSampleByPage(page).number }}
      </template>
    </paginator>
  </div>
</template>

<script>
import Paginator from '@/components/lists/Paginator';

export default {
  props: {
    value: String,
    samples: Array,
  },
  components: {
    Paginator,
  },
  methods: {
    getPageBySampleId(sampleId) {
      return this.samples.findIndex(({ id }) => id === sampleId) + 1;
    },
    getSampleByPage(page) {
      return this.samples[page - 1];
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.getPageBySampleId(this.value);
      },
      set(page) {
        this.$emit('input', this.getSampleByPage(page).id);
      },
    },
  },
};
</script>
<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .samples-paginator
    display: flex
    justify-content: flex-end
    &__label
      display: flex
      margin-bottom: 5px
      font-size: 1.2rem
      color: $color-secondary
      font-weight: bolder
    .paginator
      width: auto
</style>
